import { useState, createContext, useEffect, useContext } from "react";
import {
  getStateList,
  getUserRoleList,
  getProjectList,
  getPropertyList,
  getAccessList,
} from "../apis/data";

//context
import { AuthContext } from "./AuthContext";
import { FilterContext } from "./FilterContext";
import {
  getCohortList,
  getFormatList,
  getTaskTypes,
} from "../apis/taskManagement";
import { getAllUsersProject } from "../apis/users";

export const DataContext = createContext();

export const DataProvider = (props) => {
  const { user } = useContext(AuthContext);
  const { project, setProject } = useContext(FilterContext);
  const [stateList, setStateList] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [projectUsersList, setProjectUsersList] = useState([]);
  // const [accessList, setAccessList] = useState([]);
  const [localDate, setLocalDate] = useState(
    JSON.parse(localStorage.getItem("date"))
      ? JSON.parse(localStorage.getItem("date")).map(
          (dateString) => new Date(dateString),
        )
      : [new Date(), new Date()],
  );
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [formats, setFormats] = useState([]);
  const [cohorts, setCohorts] = useState([]);
  const [taskTypes, setTaskTypes] = useState([]);

  // Add notification (newest on top)
  const addNotification = (notif) => {
    setNotifications((prev) => [notif, ...prev]);
    setUnreadCount((prev) => prev + 1);
  };

  // Clear unread count
  const clearNotifications = () => {
    setUnreadCount(0);
  };

  const getStateData = async () => {
    const { result, err } = await getStateList();
    if (err) {
      alert("Couldn't fetch the data");
      return;
    }
    setStateList(result);
  };

  const getProjectData = async () => {
    if (user) {
      const { result, err } = await getProjectList();
      if (err) {
        alert("Couldn't fetch the data");
        return;
      }
      setProjectList(result);
      if (result && result.length && !project?.id) {
        setProject(result[0]);
      }
    }
  };

  const getUserRolesData = async () => {
    const { result, err } = await getUserRoleList();
    if (err) {
      alert("Couldn't fetch the data");
      return;
    }
    setUserRoles(result);
  };

  const getFormatsList = async () => {
    try {
      const { data, error } = await getFormatList();
      if (error) {
        alert("Couldn't fetch the data");
        return;
      }
      setFormats(data);
    } catch (error) {
      alert("Error fetching formats list");
    }
  };

  const getCohortsList = async () => {
    try {
      const { data, error } = await getCohortList();
      if (error) {
        alert("Couldn't fetch the data");
        return;
      }
      setCohorts(data);
    } catch (error) {
      alert("Error fetching cohorts list");
    }
  };

  const getTaskTypesList = async () => {
    try {
      const { result, err } = await getTaskTypes();
      if (err) {
        alert("Couldn't fetch the data");
        return;
      }
      setTaskTypes(result);
    } catch (error) {
      alert("Error fetching task types list");
    }
  };

  const getProjectUsersData = async (projectId) => {
    const { result, err } = await getAllUsersProject(projectId);
    if (err) {
      alert("Couldn't fetch project users");
      return;
    }
    setProjectUsersList(result);
  };

  // const getAccessData = async () => {
  //   const { result, err } = await getAccessList();
  //   if (err) {
  //     alert("Couldn't fetch access data");
  //     return;
  //   }
  //   setAccessList(result);
  // };

  const setDate = (newDate) => {
    localStorage.setItem("date", JSON.stringify(newDate));
    setLocalDate(newDate);
  };

  useEffect(() => {
    getStateData();
    getProjectData();
    getUserRolesData();
    // getAccessData();
    if (user) {
      getFormatsList();
      getCohortsList();
      getTaskTypesList();
    }
  }, [user]);

  useEffect(() => {
    if (project && project.id) {
      getProjectUsersData(project.id);
    }
  }, [project]);

  const state = {
    stateList,
    userRoles,
    localDate,
    projectList,
    projectUsersList,
    formats,
    cohorts,
    taskTypes,
    // accessList,
  };

  return (
    <DataContext.Provider
      value={{
        stateList: state.stateList,
        userRoles: state.userRoles,
        localDate: state.localDate,
        projectList: state.projectList,
        propertyList: state.propertyList,
        formats: state.formats,
        cohorts: state.cohorts,
        taskTypes: state.taskTypes,
        projectUsersList: state.projectUsersList,
        // accessList: state.accessList,
        setDate,
        notifications,
        unreadCount,
        addNotification,
        clearNotifications,
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
};
